import { PlusOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../../../AppContext';
import {
  MODULES,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
} from '../../../../common/constants';
import { hasPermission } from '../../../../common/utils';
import Portal from '../../../../components/Portal';
import GenresTable from '../components/GenresTable';

const Genres = () => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const [isGenresModalOpen, setIsGenresModalOpen] = useState(false);
  const [genresImages, setGenresImages] = useState([]);

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.GENRES}</div>
      </Portal>
      <Portal portalId="header-right-content">
        {hasPermission(
          PERMISSIONS_KEY?.APP_CONTENT_GENRES,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
            <Button
              className="common-button"
              size="middle"
              icon={<PlusOutlined />}
              onClick={() => {
                setIsGenresModalOpen(true);
                setGenresImages([]);
              }}
            >
              Add New Genre
            </Button>
          )}
      </Portal>
      <Portal portalId="header-right-content-phones">
        {hasPermission(
          PERMISSIONS_KEY?.APP_CONTENT_GENRES,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
            <Button
              className="common-button"
              size="middle"
              icon={<PlusOutlined />}
              onClick={() => {
                setIsGenresModalOpen(true);
                setGenresImages([]);
              }}
            >
              Add New Genre
            </Button>
          )}
      </Portal>
      <Card className="full-height-without-nav">
        <GenresTable
          isGenresModalOpen={isGenresModalOpen}
          setIsGenresModalOpen={setIsGenresModalOpen}
          genresImages={genresImages}
          setGenresImages={setGenresImages}
        />
      </Card>
    </>
  );
};

export default Genres;
